import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import b from 'b_';

import { getQueryValue } from 'client/components/filters/filters-query';
import ApiRequest from 'client/helpers/apiRequest';

const class_ = b.with('page');

interface State {
    isLoading: boolean;
    isUnsubscribed?: boolean;
}

export default class UnsubscriptionPage extends Component<RouteComponentProps, State> {
    state: State = {
        isLoading: true
    };

    componentDidMount() {
        const { location } = this.props;
        const query = getQueryValue(location.search);

        ApiRequest.get(`/api/unsubscribe/${query.token}`).then(
            () => this.setState({ isUnsubscribed: true, isLoading: false }),
            () => this.setState({ isUnsubscribed: false, isLoading: false }));
    }

    render() {
        const { isLoading, isUnsubscribed } = this.state;
        const message = isUnsubscribed
            ? 'Вы успешно отписались от рассылки'
            : 'Подписка не найдена или вы уже отписывались ранее';

        return (
            <div className={class_({ type: 'home' })}>
                <h1>Отписка от рассылки</h1>
                <div>{isLoading ? 'Загрузка...' : message}</div>
            </div>
        );
    }
}
